import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import PosicionesEtapaTorneo from '../../tablas/PosicionesEtapaTorneo.js';
import MensajeCargando from '../../UI/MensajeCargando.js';
import MensajeError from '../../UI/MensajeError.js';
import BotoneraFiltros from '../../UI/BotoneraFiltros.js';
import UserContext from '../../../context/UserContext.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import usePutURL from '../../../hooks/usePutURL.js';
import * as Funciones from '../../funciones/FuncionesTorneos.js';
import * as DTOs from '../../edicion/DTOs/TorneoPosicionesDTOs.js';
import styles from './PosicionesTorneo.module.css';

const TipoPosiciones = {
  GRABADA: 'grabada',
  CALCULADA: 'calculada',
};

const PosicionesTorneo = (props) => {
  const datosElegidos = props.datosElegidos;
  const [posiciones, setPosiciones] = useState([]);
  const [tipoPosiciones, setTipoPosiciones] = useState(TipoPosiciones.GRABADA);
  const [intentoCambioAutomatico, setIntentoCambioAutomatico] = useState(false);
  const [hayPosicionesGrabadas, setHayPosicionesGrabadas] = useState(null);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const { isGrabando, erroresPut, putData, resetErroresPut } = usePutURL();
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;

  const filtrosPosiciones = [
    { codigo: TipoPosiciones.GRABADA, descripcion: 'Grabada' },
    { codigo: TipoPosiciones.CALCULADA, descripcion: 'Calculada' },
  ];

  useEffect(() => {
    resetErroresGetLista();
    resetErroresPut();
  }, [resetErroresGetLista, resetErroresPut]);

  const url = Funciones.URLPosicionesTorneo(
    datosElegidos,
    tipoPosiciones === TipoPosiciones.CALCULADA
  );

  useEffect(() => {
    if (url) {
      fetchData(url, setPosiciones);
    } else {
      setPosiciones([]);
    }
  }, [url, fetchData]);

  // Efecto para cambiar automáticamente a "Calculada" si "Grabada" no trae datos
  useEffect(() => {
    if (
      !isCargando &&
      !erroresGetLista &&
      tipoPosiciones === TipoPosiciones.GRABADA &&
      !intentoCambioAutomatico
    ) {
      if (!posiciones || posiciones.length === 0) {
        if (puedeEditar) {
          // Solo intentar cambiar una vez para evitar loops infinitos
          setHayPosicionesGrabadas(false);
          setIntentoCambioAutomatico(true);
          setTipoPosiciones(TipoPosiciones.CALCULADA);
        }
      } else {
        setHayPosicionesGrabadas(true);
      }
    }
  }, [
    puedeEditar,
    isCargando,
    erroresGetLista,
    tipoPosiciones,
    posiciones,
    intentoCambioAutomatico,
  ]);

  // Resetear el flag de cambio automático cuando cambia la etapa
  useEffect(() => {
    setIntentoCambioAutomatico(false);
    setHayPosicionesGrabadas(null);
    setTipoPosiciones(TipoPosiciones.GRABADA);
  }, [datosElegidos.etapa]);

  const onTipoPosicionesElegido = (tipo) => {
    setTipoPosiciones(tipo);
  };

  const navigate = useNavigate();
  const onEquipoElegido = (idEquipo) => {
    navigate('/torneo/' + datosElegidos.torneo.id + '/equipo/' + idEquipo, {
      state: { datosElegidos },
    });
  };

  const onGrabarPosiciones = () => {
    if (!posiciones || posiciones.length === 0) return;
    const idTorneo = datosElegidos.torneo.id;
    const codEtapa = datosElegidos.etapa?.etapa?.codigo ?? null;
    const body = posiciones.map((p) => DTOs.saveItem(p, idTorneo, codEtapa));
    putData(`torneos/${idTorneo}/posiciones`, body, () => {
      setHayPosicionesGrabadas(true);
      setTipoPosiciones(TipoPosiciones.GRABADA);
    });
  };

  const mostrarBotonGrabar =
    puedeEditar &&
    tipoPosiciones === TipoPosiciones.CALCULADA &&
    hayPosicionesGrabadas === false &&
    posiciones.length > 0;

  return (
    <React.Fragment>
      {puedeEditar && (
        <BotoneraFiltros
          filtros={filtrosPosiciones}
          selected={tipoPosiciones}
          onFiltroElegido={onTipoPosicionesElegido}
        />
      )}
      {!isCargando && posiciones && posiciones.length > 0 && (
        <PosicionesEtapaTorneo
          torneo={datosElegidos.torneo}
          posiciones={posiciones}
          onEquipoElegido={onEquipoElegido}
        />
      )}
      {mostrarBotonGrabar && (
        <div className={styles.contenedorBotonGrabar}>
          <button className={styles.botonGrabar} onClick={onGrabarPosiciones} disabled={isGrabando}>
            {isGrabando ? 'Grabando...' : 'Grabar'}
          </button>
        </div>
      )}
      <MensajeCargando isCargando={isCargando || isGrabando} />
      <MensajeError errores={erroresGetLista || erroresPut} />
    </React.Fragment>
  );
};

export default PosicionesTorneo;
